export class Service {
  public static readonly DIGITAL = 1;
  public static readonly TIMESTAMP = 2;
  public static readonly SEND_ELECTRONIC_NOTIFICATION = 3;
  public static readonly REVIEW = 4;
  public static readonly ELECTRONIC = 5;
  public static readonly SEND_EMAIL = 6;
  public static readonly CLOUD = 7;
  public static readonly REMOTE = 8;
  public static readonly REMOTE_WITH_TIMESTAMP = 9;
  public static readonly REMOTE_WITH_LTV = 10;
  public static readonly NOTCER = 11;
}
